// Shopify Cart API Integration
document.addEventListener('DOMContentLoaded', () => {
    // FAQ Accordion Logic
    const faqQuestions = document.querySelectorAll('.faq-question');
    faqQuestions.forEach(question => {
        question.addEventListener('click', (e) => {
            e.preventDefault();
            const answer = question.nextElementSibling;
            if (!answer || !answer.classList.contains('faq-answer')) return;
            
            const isOpen = answer.classList.contains('active');
            if (isOpen) {
                answer.style.maxHeight = '0px';
                answer.classList.remove('active');
                return;
            }
            
            document.querySelectorAll('.faq-answer').forEach(item => {
                item.style.maxHeight = '0px';
                item.classList.remove('active');
            });
            
            const scrollHeight = answer.scrollHeight;
            answer.style.maxHeight = scrollHeight + "px";
            answer.classList.add('active');
        });
    });

    // Mobile Menu Toggle
    window.toggleMobileMenu = function() {
        const menuBtn = document.querySelector('.mobile-menu-btn');
        const navMenu = document.querySelector('.nav-menu');
        const body = document.body;
        
        if (menuBtn && navMenu) {
            const isActive = navMenu.classList.toggle('active');
            menuBtn.classList.toggle('active');
            body.classList.toggle('menu-open', isActive);
        }
    };

    // Carousel Logic
    const carousels = document.querySelectorAll('.carousel-container');
    carousels.forEach(carousel => {
        const track = carousel.querySelector('.carousel-track');
        if (!track) return;
        
        if (carousel.id === 'related-products-carousel' && window.innerWidth >= 769) {
            return;
        }

        const originalContent = track.innerHTML;
        track.innerHTML = originalContent + originalContent;

        let baseSpeed = 1.2;
        if (carousel.id === 'social-carousel') {
            baseSpeed = 0.8;
        }

        let paused = false;
        const canPause = carousel.id === 'reviews-carousel' || carousel.id === 'blogs-carousel';

        if (canPause) {
            carousel.addEventListener('mouseenter', () => paused = true);
            carousel.addEventListener('mouseleave', () => paused = false);
        }

        const startScrolling = () => {
            const step = () => {
                const scrollWidth = track.scrollWidth;
                const clientWidth = track.clientWidth;
                const maxScroll = scrollWidth / 2;
                const currentScroll = track.scrollLeft;

                if (maxScroll > clientWidth) {
                    if (!paused) {
                        if (currentScroll >= maxScroll - 1) {
                            track.scrollLeft = 0;
                        } else {
                            track.scrollLeft += baseSpeed;
                        }
                    }
                }
                requestAnimationFrame(step);
            };
            requestAnimationFrame(step);
        };

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                setTimeout(startScrolling, 100);
            });
        });
    });

    // Shopify Cart Functions
    async function fetchCart() {
        try {
            const response = await fetch('/cart.js');
            return await response.json();
        } catch (error) {
            console.error('Error fetching cart:', error);
            return null;
        }
    }

    async function addToCart(variantId, quantity = 1) {
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: quantity
                })
            });
            
            if (response.ok) {
                const data = await response.json();
                updateCartUI();
                return data;
            } else {
                throw new Error('Failed to add to cart');
            }
        } catch (error) {
            console.error('Error adding to cart:', error);
            alert('Failed to add product to cart. Please try again.');
        }
    }

    async function updateCartItem(variantId, quantity) {
        try {
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: quantity
                })
            });
            
            if (response.ok) {
                updateCartUI();
            }
        } catch (error) {
            console.error('Error updating cart:', error);
        }
    }

    async function removeFromCart(variantId) {
        try {
            await updateCartItem(variantId, 0);
        } catch (error) {
            console.error('Error removing from cart:', error);
        }
    }

    async function updateCartUI() {
        const cart = await fetchCart();
        if (!cart) return;

        const cartBody = document.getElementById('cart-body');
        const cartEmpty = document.getElementById('cart-empty');
        const cartItems = document.getElementById('cart-items');
        const cartItemsList = document.getElementById('cart-items-list');
        const cartSubtotal = document.getElementById('cart-subtotal');
        const cartCountBadge = document.getElementById('cart-count-badge');

        if (!cartBody) return;

        // Update cart count badge
        if (cartCountBadge) {
            const itemCount = cart.item_count;
            if (itemCount > 0) {
                cartCountBadge.textContent = itemCount > 99 ? '99+' : itemCount;
                cartCountBadge.classList.add('active');
            } else {
                cartCountBadge.classList.remove('active');
            }
        }

        if (cart.item_count === 0) {
            if (cartEmpty) cartEmpty.style.display = 'flex';
            if (cartItems) cartItems.style.display = 'none';
        } else {
            if (cartEmpty) cartEmpty.style.display = 'none';
            if (cartItems) cartItems.style.display = 'flex';
            
            if (cartItemsList) {
                cartItemsList.innerHTML = cart.items.map(item => `
                    <div class="cart-item">
                        <a href="${item.url}" class="cart-item__image-wrapper">
                            <img src="${item.image}" alt="${item.product_title}" class="cart-item__image">
                        </a>
                        <div class="cart-item__details">
                            <a href="${item.url}" class="cart-item__name">${item.product_title}</a>
                            <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
                            <div class="cart-item__quantity">
                                <button class="quantity-btn" onclick="updateCartQuantity('${item.variant_id}', ${item.quantity - 1})">−</button>
                                <input type="number" class="quantity-input" value="${item.quantity}" min="1" 
                                    onchange="updateCartQuantity('${item.variant_id}', parseInt(this.value))">
                                <button class="quantity-btn" onclick="updateCartQuantity('${item.variant_id}', ${item.quantity + 1})">+</button>
                            </div>
                            <button class="cart-item__remove" onclick="removeCartItem('${item.variant_id}')">Remove</button>
                        </div>
                    </div>
                `).join('');
            }

            if (cartSubtotal) {
                cartSubtotal.textContent = formatMoney(cart.total_price);
            }
        }
    }

    function formatMoney(cents) {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0
        }).format(cents / 100);
    }

    // Global functions for cart operations
    window.addToCartQuick = async function(variantId) {
        await addToCart(variantId, 1);
        openCartDrawer();
    };

    window.updateCartQuantity = async function(variantId, quantity) {
        if (quantity <= 0) {
            await removeFromCart(variantId);
        } else {
            await updateCartItem(variantId, quantity);
        }
    };

    window.removeCartItem = async function(variantId) {
        await removeFromCart(variantId);
    };

    // Search Drawer
    window.openSearchDrawer = function() {
        const searchDrawer = document.getElementById('search-drawer');
        if (searchDrawer) {
            searchDrawer.classList.add('active');
            searchDrawer.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
            const searchInput = document.getElementById('search-input');
            if (searchInput) {
                setTimeout(() => searchInput.focus(), 100);
            }
        }
    };

    window.closeSearchDrawer = function() {
        const searchDrawer = document.getElementById('search-drawer');
        if (searchDrawer) {
            searchDrawer.classList.remove('active');
            searchDrawer.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
            const searchInput = document.getElementById('search-input');
            if (searchInput) searchInput.value = '';
            const searchResults = document.getElementById('search-results');
            if (searchResults) {
                searchResults.innerHTML = '<div class="search-results-empty"><p>Start typing to search for products...</p></div>';
            }
        }
    };

    // Search functionality
    let searchTimeout;
    const searchInput = document.getElementById('search-input');
    const searchForm = document.getElementById('search-form');
    const searchResults = document.getElementById('search-results');

    async function performSearch(query) {
        if (!query || query.trim().length === 0) {
            if (searchResults) {
                searchResults.innerHTML = '<div class="search-results-empty"><p>Start typing to search for products...</p></div>';
            }
            return;
        }

        try {
            // Show loading state
            if (searchResults) {
                searchResults.innerHTML = '<div class="search-results-empty"><p>Searching...</p></div>';
            }

            const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`);
            const data = await response.json();
            
            if (searchResults) {
                // Shopify search suggest API returns: data.resources.results.products
                const products = data.resources?.results?.products || [];
                
                if (products.length > 0) {
                    searchResults.innerHTML = `
                        <div class="search-results-grid">
                            ${products.map(product => {
                                const imageUrl = product.image || product.featured_image || '';
                                const price = product.price ? formatMoney(product.price) : '';
                                return `
                                    <a href="${product.url}" class="search-result-item">
                                        ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" class="search-result-item__image" onerror="this.style.display='none'">` : ''}
                                        <div class="search-result-item__name">${product.title}</div>
                                        ${price ? `<div class="search-result-item__price">${price}</div>` : ''}
                                    </a>
                                `;
                            }).join('')}
                        </div>
                    `;
                } else {
                    searchResults.innerHTML = '<div class="search-results-empty"><p>No products found. Try a different search term.</p></div>';
                }
            }
        } catch (error) {
            console.error('Search error:', error);
            if (searchResults) {
                searchResults.innerHTML = '<div class="search-results-empty"><p>Error searching. Please try again.</p></div>';
            }
        }
    }

    // Live search as user types
    if (searchInput) {
        searchInput.addEventListener('input', (e) => {
            const query = e.target.value.trim();
            clearTimeout(searchTimeout);
            
            if (query.length >= 2) {
                searchTimeout = setTimeout(() => {
                    performSearch(query);
                }, 300);
            } else {
                if (searchResults) {
                    searchResults.innerHTML = '<div class="search-results-empty"><p>Start typing to search for products...</p></div>';
                }
            }
        });
    }

    // Handle form submission - navigate to search results page
    if (searchForm) {
        searchForm.addEventListener('submit', (e) => {
            const query = searchInput ? searchInput.value.trim() : '';
            if (query.length > 0) {
                // Allow default form submission to navigate to search results page
                // The form action will handle the navigation
                return true;
            } else {
                e.preventDefault();
                return false;
            }
        });
    }

    // Close search drawer when clicking overlay
    const searchDrawer = document.getElementById('search-drawer');
    if (searchDrawer) {
        const overlay = searchDrawer.querySelector('.search-drawer__overlay');
        if (overlay) {
            overlay.addEventListener('click', () => {
                closeSearchDrawer();
            });
        }
    }

    // Cart Drawer
    window.openCartDrawer = function() {
        const cartDrawer = document.getElementById('cart-drawer');
        if (cartDrawer) {
            cartDrawer.classList.add('active');
            cartDrawer.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
            updateCartUI();
        }
    };

    window.closeCartDrawer = function() {
        const cartDrawer = document.getElementById('cart-drawer');
        if (cartDrawer) {
            cartDrawer.classList.remove('active');
            cartDrawer.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
        }
    };

    // Product form submission
    const productForm = document.getElementById('product-form');
    if (productForm) {
        productForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            const formData = new FormData(productForm);
            const variantId = formData.get('id');
            if (variantId) {
                await addToCart(variantId, 1);
                openCartDrawer();
            }
        });
    }

    // Close drawers on Escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeSearchDrawer();
            closeCartDrawer();
        }
    });

    // Initialize cart UI on page load
    updateCartUI();
});
